import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Overview from './pages/Overview';
import MonitorDetail from './pages/MonitorDetail';
import CreateMonitor from './pages/CreateMonitor';
import EditMonitor from './pages/EditMonitor';
import Subscriptions from './pages/Subscriptions';
import CreateSubscription from './pages/CreateSubscription';
import EditSubscription from './pages/EditSubscription';
import Settings from './pages/Settings';
import Login from './pages/Login';
import Navbar from './components/Navbar';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition-colors duration-200">
                    <Navbar />
                    <div className="container mx-auto px-4 py-8">
                      <Routes>
                        <Route path="/" element={<Overview />} />
                        <Route path="/monitor/:id" element={<MonitorDetail />} />
                        <Route path="/monitor/:id/edit" element={<EditMonitor />} />
                        <Route path="/create" element={<CreateMonitor />} />
                        <Route path="/subscriptions" element={<Subscriptions />} />
                        <Route path="/subscriptions/create" element={<CreateSubscription />} />
                        <Route path="/subscriptions/:id/edit" element={<EditSubscription />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
